import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  FormControlLabel,
  FormHelperText,
  InputAdornment,
  Select,
  MenuItem
} from "@mui/material";
import {
  button_bg_color_for_New_Project,
  settingsModal_bg_color_dm,
} from "../../../../../constants/colors";
import { ToggleSwitch } from "../../../../Common_Components/ToggleSwitch";
import { getProfileForCalligAgent, setProfileForCalligAgent, updateProfileForCalligAgent } from "../../../../../contexts/WorkspaceUtils";
import CommonToast from "../../../../Common_Components/CommonToast";
import { useWorkspace } from "../../../../../contexts/WorkspaceContext";
import GetCountryFlagByName from "../../../settingBar/VideoGenSettings/GetCountryFlagByName";
import { countryDatas } from "../../../../../constants/countryList";
import { customTextFieldStyles } from "../../../../../constants/FormInputBoxCss";

 const userEmail = localStorage.getItem("userEmail");
//   const countryDatas = [
//   { id: 32, name: "Canada", code: "CA", mobileCode: "+1" },
//   { id: 184, name: "United States", code: "US", mobileCode: "+1" },
//    ...(userEmail=="manisha@lifetimeimmigration.com"
//     ? [ { id: 108, name: "Mauritius", code: "MU", mobileCode: "+230" },]
//     : []),
// ]

const BusinessProfile = () => {
  const theme = localStorage.getItem("theme");
  const {callingAgentUserProfileData, setCallingAgentUserProfileData} = useWorkspace()
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState("");
  const [iconType, setIconType] = useState('success');
  const [allFilterCountry, setAllFilterCountry] = useState(countryDatas);
  const [selectedCountry, setSelectedCountry] = useState(
                countryDatas.find((country) => country.name === "Canada")
              );


  useEffect(()=>{
    // if(callingAgentUserProfileData?.name === ""){
      getUserProfileData()
    // }
  },[])

  const getUserProfileData = async () => {
    try{
      const res = await getProfileForCalligAgent();
      const UserData = await res?.json();
    
      if (UserData?.status) {
          const userCountryObject = countryDatas.filter((countryObject, index)=>countryObject?.code === UserData?.data?.country)
          setSelectedCountry(userCountryObject[0])
          setCallingAgentUserProfileData({
          name: UserData?.data?.name || '',       
          country : UserData?.data?.country || "",
          phone: {
            country_code: UserData?.data?.phone?.country_code || "",
            e164: UserData?.data?.phone?.e164 || "",
            number : UserData?.data?.phone?.number || ""
          },
          email: UserData?.data?.email || '',
          website: removeProtocol(UserData?.data?.website) || '',
          calendly_link: removeProtocol(UserData?.data?.calendly_link) || "",
          follow_up_notification_email: UserData?.data?.follow_up_notification_email || '',
          enable_follow_up_notification: UserData?.data?.enable_follow_up_notification || false
        });
      } else {
        setOpen(true);
        setContent(UserData?.message);
        setIconType('error');
      }
    }catch(error){
      console.log(error)
      setOpen(true);
      setContent(error?.message);
      setIconType('error');
    }
  };
  

  const onClose = () => {
    setOpen(false);
  };

  const handleEnterBusinessName = (e) =>{
    setCallingAgentUserProfileData(prev => ({ ...prev, name: e.target.value }));

  }

  const handleEnterBusinessNumber = (e) =>{
    setCallingAgentUserProfileData(prev => ({ ...prev, phone:{...prev?.phone, number: e.target.value }}));
  }

  const handleEnterBusinessEmail = (e) =>{
    setCallingAgentUserProfileData(prev => ({ ...prev, email: e.target.value }));
  }

  const handleEnterBusinessWebsite = (e) =>{
    setCallingAgentUserProfileData(prev => ({ ...prev, website: e.target.value }));
  }

  const handleEnterFollowUpNotificationEmail = (e) =>{
    setCallingAgentUserProfileData(prev => ({ ...prev, follow_up_notification_email: e.target.value }));
  }

  const handleEnterCalendlyLink = (e) => {
    setCallingAgentUserProfileData(prev => ({...prev, calendly_link: e.target.value}))
  }

  function removeProtocol(url) {
    return url.replace(/^https?:\/\//, '');
  }
  

  const handleEnableNotificationEmail = (e) =>{
    setCallingAgentUserProfileData(prev => ({
      ...prev,
      enable_follow_up_notification: !prev.enable_follow_up_notification
    }));
  }

  const HandleSaveButtonClickForBusinessProfile =async () =>{
    try{
    const response  =  await getProfileForCalligAgent() 
    const data = await response.json();
    console.log("data_profile", data)

    const newObj = {
      id : data?.data?.id,
      name: callingAgentUserProfileData?.name,
      country: selectedCountry?.code,
      // phone: callingAgentUserProfileData?.phone == "" ? "" : `${selectedCountry?.mobileCode}${callingAgentUserProfileData?.phone.replace(/^\+1/, '')}`,
      phone: {
        country_code: selectedCountry?.mobileCode || "",
        e164: `${selectedCountry?.mobileCode}${callingAgentUserProfileData?.phone?.number}` || "",
        number : callingAgentUserProfileData?.phone?.number || ""
      },
      email: callingAgentUserProfileData?.email,
      website: callingAgentUserProfileData?.website == "" ? "" : `https://${callingAgentUserProfileData?.website}`,
      calendly_link: callingAgentUserProfileData?.calendly_link == "" ? "" : `https://${callingAgentUserProfileData?.calendly_link}`,
      follow_up_notification_email: callingAgentUserProfileData?.follow_up_notification_email,
      enable_follow_up_notification: callingAgentUserProfileData?.enable_follow_up_notification
    }

    if (data?.status){
      try{
          const res = await updateProfileForCalligAgent(data?.data?.id , newObj)
          const Responsedata = await res.json()
    
          if(Responsedata?.status){
            setOpen(true)
            setContent(Responsedata?.message)
            setIconType('success')
            await getUserProfileData()
          }else{
            setOpen(true)
            setContent(Responsedata?.message)
            setIconType('error')
          }
      }catch(error){
          console.log(error)
          setOpen(true);
          setContent(error?.message);
          setIconType('error');
      }
      }else{
        const newObj = {
          name: callingAgentUserProfileData?.name,
          country :  selectedCountry?.code || "",
          phone : {
            country_code: callingAgentUserProfileData?.phone?.country_code || "",
            e164: callingAgentUserProfileData?.phone?.e164 || "",
            number : callingAgentUserProfileData?.phone?.number || ""
          },
          // phone: callingAgentUserProfileData?.phone == "" ? "" : `${selectedCountry?.mobileCode}${callingAgentUserProfileData?.phone}`,
          email: callingAgentUserProfileData?.email,
          website:  callingAgentUserProfileData?.website == "" ? "" : `https://${callingAgentUserProfileData?.website}`,
          calendly_link:  callingAgentUserProfileData?.calendly_link == "" ? "" : `https://${callingAgentUserProfileData?.calendly_link}`,
          follow_up_notification_email: callingAgentUserProfileData?.follow_up_notification_email,
          enable_follow_up_notification: callingAgentUserProfileData?.enable_follow_up_notification
        }
        try{  
          const res = await setProfileForCalligAgent(newObj)
          const Responsedata = await res.json()
          if(Responsedata?.status){
            setOpen(true)
            setContent(Responsedata?.message)
            setIconType('success')
            await getUserProfileData()
          }else{
            setOpen(true)
            setContent(Responsedata?.message)
            setIconType('error')
          }
        }catch(error){
          console.log(error)
          setOpen(true);
          setContent(error?.message);
          setIconType('error');
        }
      }
    }catch(error){
      console.log(error)
      setOpen(true);
      setContent(error?.message);
      setIconType('error');
    }
  }

  const handleCountryCodeChange = (country) => {
    setSelectedCountry(country);
  };

  return (
    <div>
      {/* Business Profile content goes here */}

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          border:""
        }}
      >
        <Box sx={{border:""}}>
        <Typography
          sx={{
            color: "rgba(255, 255, 255, 0.90)",
            fontFamily: "Inter",
            fontSize: "24px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "20px",
            marginBottom: "16px",
            display: "flex",
            flexDirection: "start",
            border:""
          }}
        >
          Profile
        </Typography>
        <Box
          sx={{
            width: "640px",
            display: "flex",
            flexDirection: "column",
            bgcolor: theme === "dark" ? "#17182C" : "",
            borderRadius: "16px",
            border:"1px solid rgba(255, 255, 255, 0.10)",
            boxShadow:"none"
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              padding: "20px 40px 0px 40px",
            }}
          >
            <Box
            // sx={{ overflow : ((isHeightUnder700px && window ===1) || (isHeightUnder600px) && window===0) ? "scroll" : "",height: ((isHeightUnder700px && window ===1) || (isHeightUnder700px) && window===0) ? "330px" : "", }}
            >
              <Box>
                <Typography
                  id="calling-agent-profile-title"
                  variant="h6"
                  component="h2"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    height: "68px",
                    font: "Inter",
                  }}
                  style={{
                    fontFamily: "Inter",
                    fontSize: "20px",
                    fontStyle: "normal",
                    fontWeight: 600,
                    lineHeight: "20px",
                    color: theme === "dark" ? "#FFFFFF" : "",
                  }}
                >
                  Business Information
                </Typography>
              </Box>
              <Box sx={{ marginBottom: 5 }}>
                <TextField
                  type="businessName"
                  onChange={(e)=>{handleEnterBusinessName(e)}}
                  value={callingAgentUserProfileData?.name}
                  id="outlined-basic"
                  label="Business name"
                  placeholder="Enter Business name"
                  variant="outlined"
                  sx={customTextFieldStyles(false)}
                  style={{
                    width: "100%",
                    maxWidth: "100%",
                    height: "56px",
                    color: "#FFFFFF",
                    backgroundColor: "#232746",
                    borderRadius: "16px",
                    placeholderfontsize: "16px",
                  }}
                />
              </Box>

                <Box sx={{ marginBottom: 5 }}>
                              <TextField 
                                          type="text"
                                          inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                                           onChange={(e) => {
                                                const onlyNums = e.target.value.replace(/\D/g, '');
                                                  setCallingAgentUserProfileData(prev => ({ ...prev , phone : {...prev.phone, number: onlyNums} }));
                                                }}
                                          value={callingAgentUserProfileData?.phone.number}
                                          label="Business phone"
                                          variant="outlined"
                                          placeholder="1234567890"
                                          InputProps={{
                                              startAdornment: (
                                              <InputAdornment position="start" sx={{ padding: "0px"}}>
                                                  <Select
                                                  value={selectedCountry?.id || ''}
                                                  variant="standard"
                                                  style={{ width: '80px', height: "100px", padding: "0px", }}
                                                  renderValue={(selectedId) => {
                                                      const country = countryDatas.find(c => c.id === selectedId);
                                                      return (
                                                      <Box sx={{ display: "flex", flexDirection: "row", columnGap: "10px", alignItems: "center", textAlign: "center" }}>
                                                          <GetCountryFlagByName countryName={country?.name} />
                                                          <p style={{ margin: "0px", color: "rgba(255, 255, 255, 0.80)" }}>{country?.mobileCode}</p>
                                                      </Box>
                                                      );
                                                  }}
                                                  sx={{
                                                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                      border: 'none',
                                                      },
                                                      '&:hover:not(.Mui-disabled):before': {
                                                      border: 'none',
                                                      },
                                                      '&::before': {
                                                      borderBottom: 'none',
                                                      },
                                                      '&::after': {
                                                      borderBottom: 'none',
                                                      },
                                                      color: "rgba(255, 255, 255, 0.80)",
                                                      '& .MuiSvgIcon-root': {
                                                      color: '#CAC4D0', // Dropdown icon color
                                                      },
                                                    }}
                                                    MenuProps={{
                                                      PaperProps: {
                                                        sx: {
                                                          backgroundColor: '#282D51',
                                                          color: 'white',
                                                        },
                                                      },
                                                    }}
                                                  SelectProps={{
                                                      MenuProps: {
                                                      PaperProps: {
                                                          sx: {
                                                          bgcolor: '#282D51',
                                                          padding: "0px",
                                                          '& .MuiMenuItem-root.Mui-selected': {
                                                              bgcolor: '#282D51',
                                                              color: 'white',
                                                              '&:hover': {
                                                              bgcolor: '#393F69',
                                                              },
                                                          },
                                                          },
                                                      },
                                                      onClose: (event) => {
                                                          if (event?.target?.id === "search-country-input") {
                                                          event.stopPropagation();
                                                          }
                                                      }
                                                      },
                                                  }}
                                                  >
                                                  <Box sx={{ border: "", height: "200px", width: "200px", overflowX: "hidden", overflowY: "scroll", color: "#282D51", bgcolor: "#282D51", padding: "0px",scrollbarWidth: "none", "&::-webkit-scrollbar": {display: "none" } }}>
                                                      {allFilterCountry.map((country) => (
                                                      <MenuItem
                                                          onClick={() => handleCountryCodeChange(country)}
                                                          key={country?.id}
                                                          value={selectedCountry?.code || country}
                                                          sx={{
                                                          // bgcolor: country?.id === selectedCountry?.id ? "#373E6D" : '#282D51',
                                                          marginTop: '-8px',
                                                          marginBottom: '-8px',
                                                          width: '200px',
                                                          height: '56px',
                                                          '&:hover': {
                                                              bgcolor: '#393F69'
                                                          },
                                                          "&.Mui-selected": {
                                                              backgroundColor: "#373E6D !important",
                                                              color: "white",
                                                          },
                                                          }}
                                                      >
                                                          <Box sx={{ display: 'flex' }}>
                                                          <Box sx={{
                                                              display: 'flex',
                                                              flexDirection: "row",
                                                              width: '24px',
                                                              height: '24px',
                                                              marginRight: '12px',
                                                              columnGap: "10px"
                                                          }}>
                                                              <GetCountryFlagByName countryName={country?.name} />
                                                              <Typography sx={{
                                                              display: 'block',
                                                              color: "white",
                                                              fontFamily: 'Inter',
                                                              fontSize: '14px',
                                                              textAlign: 'left',
                                                              opacity: '80%'
                                                              }}>{country.name} </Typography>
                                                              <Typography component='span'
                                                              sx={{
                                                                  color: "white",
                                                                  fontFamily: 'Inter',
                                                                  fontSize: '14px',
                                                                  textAlign: 'left',
                                                                  opacity: '80%',
                                                                  marginLeft: '5px'
                                                              }}>{country.mobileCode}</Typography>
                                                          </Box>
                                                          </Box>
                                                      </MenuItem>
                                                      ))}
                                                  </Box>
                                                  </Select>
                                              </InputAdornment>
                                              )
                                          }}
                                          sx={{
                                            ...customTextFieldStyles(false),
                                                  '& input[type=number]': {
                                                    MozAppearance: 'textfield',
                                                  },
                                                  '& input[type=number]::-webkit-outer-spin-button': {
                                                    WebkitAppearance: 'none',
                                                    margin: 0,
                                                  },
                                                  '& input[type=number]::-webkit-inner-spin-button': {
                                                    WebkitAppearance: 'none',
                                                    margin: 0,
                                                  },
                                              width: "100%",
                                              maxWidth: "100%",
                                              height: "56px",
                                              color: "#FFFFFF",
                                              backgroundColor: "#232746",
                                              borderRadius: "8px",
                                              marginBottom:"5px",
                                              boxShadow: "0px 0px 80px 0px rgba(0, 0, 0, 0.40)",
                                              '& .MuiInputLabel-root': {
                                              color: 'rgba(255, 255, 255, 0.80)', // Label text color
                                              fontFamily: 'Inter',
                                              fontSize: '16px',
                                              placeholderfontsize: "16px",
                                              fontWeight: 400,
                                              },
                                              '& .MuiOutlinedInput-root': {
                                              '& input': {
                                                  color: "white",
                                                  fontFamily: 'Inter',
                                                  fontSize: '16px',
                                                  fontWeight: 400,
                                                  cursor: "text", 
                                              },
                                              '& input::placeholder': {
                                                  color: "rgba(255, 255, 255, 0.40)",
                                                  opacity: 1,
                                              },
                                              '& fieldset': {
                                                  border: "2px solid rgba(255, 255, 255, 0.60)", 
                                              },
                                              '&:hover fieldset': {
                                                  borderColor: "rgba(255, 255, 255, 0.60)", 
                                              },
                                              '&.Mui-focused fieldset': {
                                                  borderColor: "rgba(255, 255, 255, 0.80)", 
                                              },
                                              '& .MuiInputLabel-root.Mui-focused': {
                                                  color: 'rgba(255, 255, 255, 0.80)',
                                              }
                                              },
                                              '& .MuiInputLabel-root.Mui-focused': {
                                                  color: 'rgba(255, 255, 255, 1)', 
                                              },
                                          }}
                />
              </Box>

              <Box sx={{ marginBottom: 5 }}>
                <TextField
                  type="email"
                  onChange={(e)=>{handleEnterBusinessEmail(e)}}
                  value={callingAgentUserProfileData?.email}
                  id="outlined-basic"
                  label="Business email"
                  placeholder="Enter Business email"
                  variant="outlined"
                  sx={customTextFieldStyles(false)}
                  // sx={{...customTextFieldStyles(false),mt:5}}
                  style={{
                    width: "100%",
                    maxWidth: "100%",
                    height: "56px",
                    color: "#FFFFFF",
                    backgroundColor: "#232746",
                    borderRadius: "8px",
                    boxShadow: "0px 0px 80px 0px rgba(0, 0, 0, 0.40)",
                    placeholderfontsize: "16px",
                  }}
                />
              </Box>

              <Box sx={{ marginBottom: 5 }}>
                <TextField
                  type="businessWebsite"
                  onChange={(e)=>{handleEnterBusinessWebsite(e)}}
                  value={removeProtocol(callingAgentUserProfileData?.website)}
                  id="outlined-basic"
                  label="Business website"
                  placeholder="Enter Business website"
                  variant="outlined"
                  sx={customTextFieldStyles(false)}
                  // sx={{...customTextFieldStyles(false),mt:5}}
                  style={{
                    width: "100%",
                    maxWidth: "100%",
                    height: "56px",
                    color: "#FFFFFF",
                    backgroundColor: "#232746",
                    borderRadius: "8px",
                    boxShadow: "0px 0px 80px 0px rgba(0, 0, 0, 0.40)",
                    placeholderfontsize: "16px",
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography
                          sx={{
                            color: "rgba(255, 255, 255, 0.8)", 
                            fontWeight: 500,
                            fontSize: "16px",
                          }}
                        >
                          https://
                        </Typography>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>

              <Box sx={{ marginBottom: 5 }}>
                <TextField
                  type="text"
                  onChange={(e)=>{handleEnterCalendlyLink(e)}}
                  value={removeProtocol(callingAgentUserProfileData?.calendly_link)}
                  id="outlined-basic"
                  label="Calendly link"
                  placeholder="Enter Your Calendly Link"
                  variant="outlined"
                  sx={customTextFieldStyles(false)}
                  // sx={{...customTextFieldStyles(false),mt:5}}
                  style={{
                    width: "100%",
                    maxWidth: "100%",
                    height: "56px",
                    color: "#FFFFFF",
                    backgroundColor: "#232746",
                    borderRadius: "8px",
                    boxShadow: "0px 0px 80px 0px rgba(0, 0, 0, 0.40)",
                    placeholderfontsize: "16px",
                  }}
                    InputProps={{
                                        startAdornment: (
                                          <InputAdornment position="start">
                                            <Typography
                                              sx={{
                                                color: "rgba(255, 255, 255, 0.8)", 
                                                fontWeight: 500,
                                                fontSize: "16px",
                                              }}
                                            >
                                              https://
                                            </Typography>
                                          </InputAdornment>
                                        ),
                                      }}
                />
                 <FormHelperText
                  sx={{
                    color: "#CAC4D0",
                    fontFamily: "Inter",
                    fontSize: "12px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "16px",
                    margin: "4px 0px 0px 16px",
                    alignSelf: "start",

                  }}
                >
                  {`Customers will be able to book calls with you using this link`}
                </FormHelperText>
              </Box>

              <Box>
                <Typography
                  id="audio-settings-title"
                  variant="h6"
                  component="h2"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: "40px",
                    font: "Inter",
                  }}
                  style={{
                    fontFamily: "Inter",
                    fontSize: "20px",
                    fontStyle: "normal",
                    fontWeight: 600,
                    lineHeight: "20px",
                    color: theme === "dark" ? "#FFFFFF" : "",
                  }}
                >
                  Follow up notification
                </Typography>
              </Box>

              <Box sx={{ marginBottom: 5 }}>
                <TextField
                  type="email"
                  onChange={(e)=>{handleEnterFollowUpNotificationEmail(e)}}
                  value={callingAgentUserProfileData?.follow_up_notification_email}
                  id="outlined-basic"
                  label="Notification email address"
                  placeholder="Notification email address"
                  variant="outlined"
                  sx={customTextFieldStyles(false)}
                  // sx={{...customTextFieldStyles(false),mt:5}}
                  style={{
                    width: "100%",
                    maxWidth: "100%",
                    height: "56px",
                    color: "#FFFFFF",
                    backgroundColor: "#232746",
                    borderRadius: "8px",
                    boxShadow: "0px 0px 80px 0px rgba(0, 0, 0, 0.40)",
                    placeholderfontsize: "16px",
                  }}
                />
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  columnGap: "12px",
                }}
              >
                <FormControlLabel onClick={(e)=>{handleEnableNotificationEmail(e)}}
                  control={
                    <ToggleSwitch
                      sx={{ transform: "scale(0.8)" }}
                      // defaultChecked={callingAgentUserProfileData?.enable_follow_up_notification}
                      checked={callingAgentUserProfileData?.enable_follow_up_notification}
                    />
                  }
                  // label=""
                  // labelPlacement=""
                  sx={{
                    whiteSpace: "nowrap",
                    margin: 0, // Removes default margin
                    maxWidth: "100%", // Ensures it doesn't exceed the parent's width
                    display: "flex",
                    alignItems: "center",
                  }}
                />
                <Typography
                  id=""
                  variant="h6"
                  component="h2"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    font: "Inter",
                  }}
                  style={{
                    fontFamily: "Inter",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "20px",
                    color: theme === "dark" ? "#FFFFFF" : "",
                  }}
                >
                  Enable follow up notification
                </Typography>
                </Box>
                </Box>
              </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              // boxShadow: "0px -4px 8px 0px rgba(0, 0, 0, 0.12)",
              p: 5,
            }}
          >
            <Button
              variant="contained"
                onClick={() => HandleSaveButtonClickForBusinessProfile()}
              sx={{
                backgroundColor:
                  theme === "dark" ? button_bg_color_for_New_Project : "",
                "&:hover": {
                  backgroundColor: "#FFD9AA",
                },
                color: "#17182C",
                fontSize: "16px",
                fontWeight: 600,
                textTransform: "none",
                fontFamily: "Inter, sans-serif",
                width: "100%",
              }}
            >
              Save
            </Button>
          </Box>
        </Box>
        </Box>
      </Box>
      <CommonToast open={open} onClose={onClose} content={content} iconType={iconType} bgColor={"#282D51"}/>
    </div>
  );
};

export default BusinessProfile;
